import React from 'react';
import imgBannerUser from 'assets/img/financial_help_banner.png';
import 'assets/scss/financial-help-banner.scss';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { Button } from '@material-ui/core';
import checkIsMobile from 'utils/CheckIsMobile';

export const FinancialHelpBanner = () => {
	const size = checkIsMobile() ? 'medium' : 'large';

	return (
		<div className="banner-ayuda-container">
			<img src={imgBannerUser} alt="ayuda financiera" />

			<h2 className="title-3 primary-color">Descubre cuál es el monto que te podemos prestar</h2>
			<p className="banner-ayuda-bajada subtitle-1 gris-6">
				Financiamos hasta el 80% del valor de tu vehiculo
			</p>
			<Button
				variant="contained"
				color="primary"
				size={size}
				className="home-button"
				endIcon={<ArrowForwardIcon />}
				onClick={() => {
					window.location.href = 'https://financiamiento.crediautos.cl/ayuda-financiera/';
				}}
			>
				QUIERO SABER
			</Button>
		</div>
	);
};
